module.exports = __webpack_public_path__ + "img/fond-zebre-md@2x.ead85e5b.jpg";